import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Proovi rohkem üldisemaid märksõnu.

  <span style="color:#85c1dc;">**FI:**</span>
  Kokeile yleisempiä avainsanoja.

  <span style="color:#85c1dc;">**RU:**</span>
  Попробуйте использовать более общие ключевые слова.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1657 = msg(
  mf`Proovi rohkem üldisemaid märksõnu.`,
  mf`Kokeile yleisempiä avainsanoja.`,
  mf`Попробуйте использовать более общие ключевые слова.`,
)

export { m1657 as 'w.module.no-results.search.suggestions.items.try-more-generic-terms' }